module.exports = __webpack_public_path__ + "img/weilan.0d3fa2fb.png";